import React, { useEffect, useState } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { ProtectedRoute } from '../../routes/ProtectedRoute';
import Home from '@components/Home';
import SignIn from '@components/SignIn';
import Library from '@components/Library';
import ItemDetail from '@components/Library/ItemDetail';
import Sync from '@components/Sync';
import Settings from '@components/Settings';
import Extension from '@components/Extension';
import Navigation from './Navigation';
import { api } from '../../api/client';
export var App = function () {
    var _a = useState(null), user = _a[0], setUser = _a[1];
    var _b = useState(false), checked = _b[0], setChecked = _b[1];
    useEffect(function () {
        api
            .whoami()
            .then(setUser)
            .catch(function () { return setUser(null); })
            .finally(function () { return setChecked(true); });
    }, []);
    if (!checked) {
        return null;
    }
    return (React.createElement(BrowserRouter, null,
        React.createElement(Switch, null,
            React.createElement(Route, { exact: true, path: "/" },
                React.createElement(Navigation, { loggedIn: !!user }),
                React.createElement(Home, null)),
            React.createElement(Route, { exact: true, path: "/signin" },
                React.createElement(SignIn, null)),
            React.createElement(ProtectedRoute, { exact: true, path: "/library", component: Library, loggedIn: !!user }),
            React.createElement(ProtectedRoute, { exact: true, path: "/library/:id", component: ItemDetail, loggedIn: !!user }),
            React.createElement(ProtectedRoute, { exact: true, path: "/sync", component: Sync, loggedIn: !!user }),
            React.createElement(ProtectedRoute, { exact: true, path: "/settings", component: Settings, loggedIn: !!user }),
            React.createElement(ProtectedRoute, { exact: true, path: "/extension", component: Extension, loggedIn: !!user }))));
};
export default App;
